<template>
  <div class="home">
    <div class="wrapper-content">
      <div class="breadcrumb_box">
        <div class="container-fluid">
          <h2>{{ $t('message.Profile') }}</h2>
        </div>
      </div>

      <div class="addmoney newaddress profilePage">
         <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <div class="add-newaddresss">
                <div class="profilePartTop">
                  <a href="/edit-profile" class="editProfileBtn">
                    <img src="../assets/images/edit-icon.svg" />
                    <span>{{ $t('message.Edit') }}</span>
                  </a>
                  <div class="profile-edit-photo">
                    <div class="round-profile">
                      <!-- <img
                        v-lazy="imageBaseUrl+profile_details.image"
                        alt="logo"
                        v-if="profile_details.image"
                      />-->
                      <img src="../assets/images/download.png" alt="user-img" />
                    </div>
                  </div>
                </div>
                {{profile.image}}
                <div class="panel">
                  <ul class="profileTopList">
                    <li>
                      <a href="/subcription">
                        {{profile.subscription}}
                        <span>{{ $t('message.Subscriptions') }}</span>
                      </a>
                    </li>
                    <li>
                      <a href="/wallet" class="moneyLink">
                        {{currency}}{{walletBal}}
                        <span>{{ $t('message.Wallet') }} {{ $t('message.Money') }}</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="userDetailsprofile panel">
                <ul>
                  <li>
                    <span>
                      <i class="fa fa-user"></i>
                    </span>
                    <p>{{profile_details.name}}</p>
                  </li>
                  <li>
                    <span>
                      <i class="fa fa-phone"></i>
                    </span>
                    <p>+{{countryCode}} {{profile_details.phoneNo}}</p>
                  </li>
                  <li>
                    <span>
                      <i class="fa fa-map-marker"></i>
                    </span>
                    <p>
                      <b>{{profile_details.title}}</b>
                      {{profile_details.address}}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProfileDetails } from "./../services/api";
import Vue from "vue";
import VueLazyload from "vue-lazyload";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: "giphy.gif",
  attempt: 1
});
export default {
  components: {
    Loading
  },

  data() {
    return {
      isLoading: false,
      fullPage: true,
      currency: localStorage.getItem("CurrencySymbol"),
      countryCode: localStorage.getItem("countryCode"),
      profile_details: "",
      profile: "",
      imageBaseUrl: "https://trakop.s3.amazonaws.com/",
      logoImg: localStorage.getItem("logoImg"),
      walletBal: localStorage.getItem("walletBalance")
    };
  },
  created() {
    this.getProfile();
  },
  methods: {
    getProfile() {
      if (!localStorage.getItem("userName")) {
        localStorage.clear();
        this.$router.push({ name: "register" });
      } else {
        var requestData = {
          user_id: localStorage.getItem("userId"),
          token: localStorage.getItem("token"),
          vendor_id: localStorage.getItem("vendorId")
        };
        this.isLoading=true
        getProfileDetails(requestData)
          .then(result => {
            console.log("dd", result);
            if (result.data.successCode === 1) {
               this.isLoading=false
              this.profile = result.data;
              this.profile_details = result.data.profile;
            } else if (
              result.data.successCode === 0 &&
              result.data.messageCode === 1053
            ) {
              localStorage.clear();
              this.$router.replace({ name: "register" });
            }
          })
          .catch(error => {
            return;
          });
      }
    }
  }
};
</script>
